export const boardStatusFilter = [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Archive", value: "archive" },
];
